import mainImg from "../../../assets/door-straightner.webp";
import thumb1 from "../../../assets/door-straightner.webp";
import thumb2 from "../../../assets/door-straightner.webp";

import mainImg1 from "../../../assets/shoe-rack-fittning.webp";
import thumb3 from "../../../assets/shoe-rack-fittning.webp";
import thumb4 from "../../../assets/shoe-rack-fittning.webp";

import mainImg2 from "../../../assets/rolling-slider.webp";
import thumb5 from "../../../assets/roller-slider-thumb-one.webp";
import thumb6 from "../../../assets/rolling-slider-thumb-two.webp";

import mainImg3 from "../../../assets/sky-track-with-cover.webp";
import thumb7 from "../../../assets/sky-track-with-cover.webp";
import thumb8 from "../../../assets/sky-track-with-cover.webp";

import mainImg4 from "../../../assets/bed-fitting-without-gas-spring.webp";
import thumb9 from "../../../assets/bed-fitting-without-gas-spring.webp";
import thumb10 from "../../../assets/bed-fitting-without-gas-spring.webp";


import mainImg5 from "../../../assets/bed fitting gas spring.webp";
import thumb11 from "../../../assets/bed fitting gas spring-thumb-one.webp";
import thumb12 from "../../../assets/bed fitting gas spring-thumb-two.webp";

export const cornerSolutions = [
 {
  code: "CS-01",
  name: "DOOR STRAIGHTENER (2m)",
  category: "door fitting",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  // ✅ PRICE
  price: "₹585",
  oldPrice: "₹1999",
  sku: "7542",
  stock: "In Stock",

  // ✅ LINKS
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Door Straightener 2m Inquiry",

  // ✅ VIDEO (add/change if you want)
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESCRIPTION
  short:
    "Door Straightener (2m) is a high-performance hardware solution designed to prevent bending or warping in tall cabinet doors. It ensures long-term stability, maintains alignment, and improves the durability of modular kitchen and wardrobe shutters.",

  // ✅ FEATURES
  features: [
    "Prevents bending and warping in tall cabinet doors",
    "2 meter length ideal for full-height doors",
    "Maintains proper door alignment and structure",
    "Strong and durable construction",
    "Suitable for modular kitchens and wardrobes",
    "Improves lifespan of cabinet shutters"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium / Steel" },
    { label: "Length", value: "2 Meter" },
    { label: "Usage", value: "Tall Cabinet Doors" },
    { label: "Installation", value: "Internal Door Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Door Straightener",
      code: "7542",
      size: "2m",
      finish: "Matte / Aluminium"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Door Straightener (2m)?",
      answer:
        "It is a hardware fitting used to keep tall cabinet doors straight and prevent bending or warping over time."
    },
    {
      question: "Where is it used?",
      answer:
        "It is commonly installed inside modular kitchen shutters, wardrobes, and tall cabinet doors."
    },
    {
      question: "Why is a door straightener important?",
      answer:
        "It maintains alignment and prevents deformation, especially in long or heavy doors."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality metal for long-lasting performance."
    },
    {
      question: "Is it suitable for all doors?",
      answer:
        "It is ideal for tall or full-height cabinet doors where bending is a common issue."
    }
  ]
},



{
  code: "CS-02",
  name: "SHOE RACK FITTING",
  category: "door fitting",

  mainImage: mainImg1,
  thumbnails: [thumb3, thumb4],

  // ✅ PRICE
  price: "₹280",
  oldPrice: "₹1699",
  sku: "CS-02",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Shoe Rack Fitting Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/TJlGBmIX68c",

  // ✅ SHORT DESCRIPTION
  short:
    "Shoe Rack Fitting is a smart and practical hardware solution designed to organize footwear efficiently inside cabinets and wardrobes. It provides strong support, smooth usability, and keeps shoes neatly arranged for easy access in modern modular storage systems.",

  // ✅ FEATURES
  features: [
    "Efficiently organizes shoes inside cabinets",
    "Strong and durable construction",
    "Provides stable support for rack shelves",
    "Easy access and neat arrangement of footwear",
    "Ideal for wardrobes and entryway storage",
    "Easy installation and low maintenance"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel / Metal" },
    { label: "Usage", value: "Shoe Storage" },
    { label: "Installation", value: "Cabinet Mount" },
    { label: "Finish", value: "Chrome / Powder Coated" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Shoe Rack Fitting",
      code: "7769",
      size: "2 LAYER",
      finish: ""
    }
    ,
     {
      item: "Shoe Rack Fitting",
      code: "7697",
      size: "3 LAYER",
      finish: ""
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Shoe Rack Fitting?",
      answer:
        "It is a hardware accessory used to install and support shoe racks inside cabinets or wardrobes."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in wardrobes, entry cabinets, and modular furniture for shoe storage."
    },
    {
      question: "What are the benefits?",
      answer:
        "It helps keep footwear organized, saves space, and makes shoes easy to access."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality metal for long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be installed easily using standard fittings and screws."
    }
  ]
},
  

 {
  code: "CS-03",
  name: "40KG PREMIUM SLIDING ROLLER",
  category: "door fitting",

  mainImage: mainImg2,
  thumbnails: [thumb5, thumb6],

  // ✅ PRICE
  price: "₹1484",
  oldPrice: "₹1299",
  sku: "40OPK756",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=40KG Premium Sliding Roller Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/58kvBNN55j4",

  // ✅ SHORT DESCRIPTION
  short:
    "40KG Premium Sliding Roller is a high-performance hardware solution designed for smooth and effortless sliding door operation. Built with durable materials and precision engineering, it supports up to 40kg load capacity, making it ideal for wardrobes, sliding cabinets, and modern modular furniture.",

  // ✅ FEATURES
  features: [
    "Supports sliding doors up to 40kg weight",
    "Smooth and silent sliding mechanism",
    "High-quality durable construction",
    "Stable and vibration-free movement",
    "Ideal for wardrobes and sliding cabinets",
    "Long-lasting and low maintenance"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel + Nylon Wheel" },
    { label: "Load Capacity", value: "Up to 40KG" },
    { label: "Usage", value: "Sliding Doors" },
    { label: "Installation", value: "Top / Bottom Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Sliding Roller",
      code: "40OPK756",
      size: "",
      finish: "Green"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a 40KG Premium Sliding Roller?",
      answer:
        "It is a heavy-duty sliding roller designed to support doors up to 40kg with smooth and stable movement."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in wardrobes, sliding doors, and modular furniture systems."
    },
    {
      question: "What is the load capacity?",
      answer:
        "It can handle sliding doors weighing up to 40 kilograms."
    },
    {
      question: "Does it provide smooth operation?",
      answer:
        "Yes, it ensures smooth, silent, and vibration-free sliding."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-term performance."
    }
  ]
},
 {
  code: "CS-04",
  name: "SKY TRACK WITH COVER",
  category: "door fitting",

  mainImage: mainImg3,
  thumbnails: [thumb7, thumb8],

  // ✅ PRICE (optional add kiya)
  price: "₹2204",
  oldPrice: "₹2999",
  sku: "7451",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Sky Track With Cover Inquiry",

  // ✅ VIDEO (optional)
  video: "https://www.youtube.com/embed/inOXPUHN9yg",

  // ✅ SHORT DESCRIPTION (upgrade)
  short:
    "Sky Track with Cover is a premium sliding door track system designed for smooth, stable, and noise-free door movement. It comes with a protective cover that not only enhances the overall look but also protects the track from dust and external damage. Built from high-quality materials, it ensures long-lasting performance and is ideal for wardrobes, cabinets, and modern modular furniture sliding systems.",

  // ✅ FEATURES (improved)
  features: [
    "Premium quality sliding track for smooth door movement",
    "Protective cover for clean finish and dust protection",
    "Strong and durable construction for long life",
    "Noise-free and stable sliding performance",
    "Ideal for wardrobes, cabinets, and modular furniture",
    "Enhances overall aesthetics of sliding systems"
  ],

  // ✅ SPECIFICATIONS (added)
  specifications: [
    { label: "Material", value: "Aluminium / Steel" },
    { label: "Usage", value: "Sliding Door System" },
    { label: "Installation", value: "Top Mount" },
    { label: "Finish", value: "Powder Coated / Matte" }
  ],

  // ✅ SPEC TABLE (optional but useful)
  specTable: [
    {
      item: "Sky Track",
      code: "7451",
      size: "8 FEET",
      finish: "Matte / Powder Coated"
    },
    {
      item: "Sky Track",
      code: "7698",
      size: "10FEET",
      finish: "Matte / Powder Coated"
    },
    {
      item: "Sky Track",
      code: "7452",
      size: "12 FEET",
      finish: "Matte / Powder Coated"
    },
  ],

  // ✅ FAQ (refined)
  faq: [
    {
      question: "What is Sky Track with Cover?",
      answer:
        "It is a sliding door track system with a protective cover designed for smooth movement and a clean finished look."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in wardrobes, sliding cabinets, and modular furniture systems."
    },
    {
      question: "What is the purpose of the cover?",
      answer:
        "The cover protects the track from dust and damage while enhancing the overall appearance."
    },
    {
      question: "Does it provide smooth sliding?",
      answer:
        "Yes, it ensures smooth, stable, and noise-free sliding operation."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    }
  ]
},
  {
  code: "CS-05",
  name: "BED FITTING WITHOUT GAS SPRING",
  category: "door fitting",

  mainImage: mainImg4,
  thumbnails: [thumb9, thumb10],

  // ✅ PRICE
  price: "₹2210",
  oldPrice: "₹2999",
  sku: "7238",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/bed-fitting-without-gas-spring.pdf",
  inquiry: "https://wa.me/919650100908?text=Bed Fitting Without Gas Spring Inquiry",

  // ✅ VIDEO (optional)
  video: "https://www.youtube.com/embed/inOXPUHN9yg",

  // ✅ SHORT DESCRIPTION (upgrade)
  short:
    "Bed Fitting Without Gas Spring is a heavy-duty lifting mechanism designed for storage beds that operate without gas springs. It provides strong structural support and allows smooth manual lifting of the bed frame, giving easy access to under-bed storage. Built with high-quality metal, it ensures durability, stability, and long-term performance, making it a reliable choice for modular furniture and modern storage bed systems.",

  // ✅ FEATURES (improved)
  features: [
    "Heavy-duty mechanism for lift-up storage beds",
    "Designed for manual lifting without gas spring",
    "Strong metal construction for high durability",
    "Provides easy access to under-bed storage",
    "Stable and reliable lifting support",
    "Ideal for modular furniture and modern beds"
  ],

  // ✅ SPECIFICATIONS (added)
  specifications: [
    { label: "Material", value: "Heavy Duty Steel" },
    { label: "Usage", value: "Storage Bed Lifting System" },
    { label: "Mechanism", value: "Manual Lift" },
    { label: "Installation", value: "Side Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Bed Fitting",
      code: "7238",
      size: "900",
      finish: ""
    },
{
      item: "Bed Fitting",
      code: "7239",
      size: "1200MM",
      finish: ""
    },

    {
      item: "Bed Fitting",
      code: "7240",
      size: "1500MM",
      finish: ""
    },

  ],

  // ✅ FAQ (refined)
  faq: [
    {
      question: "What is Bed Fitting Without Gas Spring?",
      answer:
        "It is a manual lifting mechanism used in storage beds that operates without a gas spring."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in storage beds and modular furniture with lift-up bed frames."
    },
    {
      question: "How does it work?",
      answer:
        "The bed frame is lifted manually using the strong metal fitting which supports the structure."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from heavy-duty metal for long-lasting strength and performance."
    },
    {
      question: "Does it provide storage access?",
      answer:
        "Yes, it allows easy and convenient access to the storage space under the bed."
    }
  ]
},
{
  code: "CS-06",
  name: "17\" GAS SPRING FOR BED",
  category: "door fitting",

  mainImage: mainImg5,
  thumbnails: [thumb11, thumb12],

  // ✅ PRICE
  price: "₹689",
  oldPrice: "₹1499",
  sku: "CS-17",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=17 Inch Gas Spring Bed Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/QNas4xkyxAQ",

  // ✅ SHORT DESCRIPTION (fixed)
  short:
    "17\" Gas Spring for Bed is a high-performance lifting support mechanism designed for modern storage beds. It ensures smooth, controlled, and effortless lifting of the bed frame while securely holding it in position. Made from high-quality materials, it provides excellent durability, stability, and long-lasting performance, making it an ideal solution for lift-up storage bed systems in modular furniture.",

  // ✅ FEATURES (fixed)
  features: [
    "17 inch gas spring for lift-up storage beds",
    "Smooth and controlled lifting mechanism",
    "Strong support to hold bed frame in open position",
    "High-quality durable construction",
    "Ensures safe and stable operation",
    "Ideal for modern modular furniture"
  ],

  // ✅ SPECIFICATIONS (fixed)
  specifications: [
    { label: "Material", value: "Steel Cylinder" },
    { label: "Size", value: "17 Inch" },
    { label: "Usage", value: "Bed Lifting Support" },
    { label: "Mechanism", value: "Gas Hydraulic" }
  ],

  // ✅ SPEC TABLE (fixed)
  specTable: [
    {
      item: "Gas Spring",
      code: "7391",
      size: "50kg",
      finish: "Black / Powder Coated"
    },
    {
      item: "Gas Spring",
      code: "7392",
      size: "75kg",
      finish: "Black / Powder Coated"
    },
    {
      item: "Gas Spring",
      code: "7393",
      size: "100kg",
      finish: "Black / Powder Coated"
    },
    {
      item: "Gas Spring",
      code: "7394",
      size: "125kg",
      finish: "Black / Powder Coated"
    },
    {
      item: "Gas Spring",
      code: "7395",
      size: "150kg",
      finish: "Black / Powder Coated"
    },
    {
      item: "Gas Spring",
      code: "7396",
      size: "175kg",
      finish: "Black / Powder Coated"
    },
    {
      item: "Gas Spring",
      code: "7397",
      size: "200kg",
      finish: "Black / Powder Coated"
    },
  ],

  // ✅ FAQ (fixed)
  faq: [
    {
      question: "What is a 17\" Gas Spring for Bed?",
      answer:
        "It is a hydraulic lifting support used in storage beds to raise and hold the bed frame smoothly."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly used in lift-up storage beds and modular furniture systems."
    },
    {
      question: "What is the benefit of using a gas spring?",
      answer:
        "It provides smooth, controlled lifting and safely holds the bed frame in an open position."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily installed with standard bed lifting fittings."
    }
  ]
},
];
